import React from 'react';
import { Section, Stack } from '@fiverr-private/layout_components';
import { Heading, Text, Typography } from '@fiverr-private/typography';
import { I18n } from '@fiverr-private/i18n-react';
import { ROLLOUTS } from '@fiverr-private/listing_experiments';
import type { ClientInitialProps } from '@fiverr-private/listing_types';
import { GenerateBrief } from './components/GenerateBrief';
import { OrDivider } from './components/OrDivider';

const DM_PREFIX = 'listing_results.empty_results.empty_search_results.dynamic_matching';

interface EmptySearchResultsProps {
    currency: ClientInitialProps['currency'];
    rollouts?: Record<string, boolean>;
}

export const EmptySearchResults = ({ currency, rollouts }: EmptySearchResultsProps) => {
    const isInMiraAgenticBriefsRollout = rollouts?.[ROLLOUTS.CROWS_PYTHONS_AGENTIC_BRIEFS];
    const headerKey = isInMiraAgenticBriefsRollout ? `${DM_PREFIX}.mira_header` : `${DM_PREFIX}.header`;

    return (
        <Section>
            <Stack paddingY="8" alignItems="center" direction="column" gap="10">
                <Stack alignItems="center" direction="column" gap="10">
                    <Stack alignItems="center" direction="column" gap="6">
                        <Stack alignItems="center" direction="column" gap="2">
                            <Heading width={{ default: '100%', sm: '326px' }} as="h5" textAlign="center">
                                <I18n k="listing_results.empty_results.empty_search_results.title" />
                            </Heading>
                            <Text width={{ default: '100%', sm: '380px' }} color="bodySecondary" textAlign="center">
                                <I18n k="listing_results.empty_results.empty_search_results.sub_title" />
                            </Text>
                        </Stack>
                    </Stack>
                </Stack>
                <OrDivider />
                <Typography fontSize="b_md" color="grey_1200">
                    <I18n k={headerKey} />
                </Typography>
                <GenerateBrief currency={currency} isInMiraAgenticBriefsRollout={isInMiraAgenticBriefsRollout} />
            </Stack>
        </Section>
    );
};
